import { Warning } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import ConfirmationDialog from './ConfirmationDialog';

export default function WholeSaleDialog({ open, onClose, onSave, isLoading }) {
  const { t } = useTranslation('orders');

  return (
    <ConfirmationDialog
      open={open}
      onClose={onClose}
      onSave={onSave}
      isLoading={isLoading}
      icon={Warning}
      iconColor="warning"
      title={t('workOrderStatus.wholeSale.title')}
      description={t('workOrderStatus.wholeSale.description')}
      showNotesField
      notesRequired
      notesTitle={t('workOrderStatus.wholeSale.notesTitle')}
      yesLabel={t('workOrderStatus.wholeSale.yes')}
      noLabel={t('workOrderStatus.wholeSale.noWait')}
    />
  );
}
